
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "5 exemples de FAQ pour votre site internet",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Cet article donne des conseils pour créer une FAQ utile tout en optimisant votre site pour les moteurs de recherche.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "5 exemples de FAQ pour votre site internet",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article donne des conseils pour créer une FAQ utile tout en optimisant votre site pour les moteurs de recherche.",
        },
      ],
    };
  },
};
